export const enum Events {
  SESSION_STARTED = 'session_start',
  FIRST_PAGE_COMPLETED = 'first_page_completed',
  AB_SEGMENT = 'ab_segment',
  QUESTION_COMPLETED = 'question_page_completed',
  EMAIL_PAGE_SHOW = 'email_page_show',
  EMAIL_PAGE_COMPLETED = 'email_page_completed',
  PRESALE_PAGE_SHOW = 'presale_page_show',
  PRESALE_PAGE_COMPLETED = 'presale_page_completed',
  PRESALE_PAGE_SCROLLED = 'presale_page_scrolled',
  SALE_SCREEN_SHOW = 'plans_page_show',
  TERMS_OF_USE = 'terms_of_use_tap',
  PRIVACY_POLICY = 'privacy_policy_tap',
  NEED_HELP = 'need_help_tap',
  TRIAL_PRICE_PAGE_SHOWN = 'trial_price_page_show',
  TRIAL_PRICE_PAGE_COMPLETED_SHOWN = 'trial_price_page_completed',
  UPSELL_SUBSCRIPTION_TOGGLE_ENABLE = 'upsell_subscription_toggle_enable',
  UPSELL_SUBSCRIPTION_TOGGLE_DISABLE = 'upsell_subscription_toggle_disable',
  PURCHASE_SHOW = 'subs_purchase_show',
  PAYMENT_METHOD_SELECTED = 'payment_method_selected',
  PURCHASE_STARTED = 'subs_purchase_started',
  PURCHASE_STARTED_PAYPAL = 'subs_purchase_started_paypal',
  PURCHASE_COMPLETED = 'subs_purchase_completed',
  PURCHASE_FAILED = 'subs_purchase_failed',
  INAPP_PURCHASE_STARTED = 'inapp_purchase_started',
  INAPP_PURCHASE_COMPLETED = 'inapp_purchase_completed',
  INAPP_PURCHASE_FAILED = 'inapp_purchase_failed',
  PURCHASE_SCREEN_CLOSED = 'subs_purchase_screen_close',
  PLANS_PAGE_BUTTON_TAP = 'plans_page_button_tap',
  PLANS_PAGE_SCROLLED = 'plans_page_scrolled',
  CANCEL_OFFER_PAGE_SHOW = 'cancel_offer_page_show',
  CANCEL_OFFER_PAGE_ANSWER = 'cancel_offer_page_answer',
  CANCEL_OFFER_PAGE_CLOSE = 'cancel_offer_page_close',
  CREATE_ACCOUNT_SHOW = 'create_account_page',
  LOGIN_METHOD_SELECTED = 'login_method_selected',
  OTHER_SIGN_UP_OPTION_TAP = 'other_sign_up_option_tap',
  ACCOUNT_CREATED = 'account_created',
  ACCOUNT_CREATION_FAILED = 'account_creation_failed',
  FINISH_ACCOUNT_SCREEN_VIEW = 'finish_account_screen_view',
  DOWNLOAD_BTN_PRESSED = 'download_button_press',
  FINISHING_TOUCHES_SCREEN_SHOW = 'finishing_touches_screen_show',
  FINISHING_TOUCHES_SCREEN_CONFIRM = 'finishing_touches_screen_confirm',
  UPSELL_PURCHASE_SHOW = 'upsell_purchase_show',
  UPSELL_PURCHASE_CLOSE = 'upsell_purchase_close',
  PLANS_PAGE_VIDEO_TAP = 'plans_page_video_tap',
  UPSELL_COACHING_PURCHASE_SHOW = 'upsell_coaching_purchase_show',
  UPSELL_COACHING_PURCHASE_CLOSE = 'upsell_coaching_purchase_close',
  UPSELL_COACHING_PAGE_SCROLLED = 'upsell_coaching_page_scrolled',
  UPSELL_COACHING_BUTTON_TAP = 'upsell_coaching_button_tap',
  UPSELL_COACHING_POPUP_SHOW = 'upsell_coaching_popup_show',
  UPSELL_COACHING_POPUP_CLOSE = 'upsell_coaching_popup_close',
  UPSELL_SUBSCRIPTION_SELECTED = 'upsell_subscription_selected',
  COOKIES_BANNER_SHOW = 'cookies_banner_show',
  COOKIES_BANNER_SETTINGS_TAP = 'cookies_banner_settings_tap',
  COOKIES_ACCEPT_ALL_TAP = 'cookies_accept_all_tap',
  COOKIES_REJECT_ALL_TAP = 'cookies_reject_all_tap',
  COOKIES_SETTINGS_TOGGLE_ENABLE = 'cookies_settings_toggle_enable',
  COOKIES_SETTINGS_TOGGLE_DISABLE = 'cookies_settings_toggle_disable',
  COOKIES_SETTING_CONFIRM_CHOICES_TAP = 'cookies_setting_confirm_choices_tap',
  COOKIES_SETTINGS_SCREEN_CLOSE = 'cookies_settings_screen_close',
  COOKIES_SETTINGS_EXPAND_OPTION_TAP = 'cookies_settings_expand_option_tap',
  COOKIES_POLICY_TAP = 'cookies_policy_button_tap',
}

export const enum EventLoggerInstanceName {
  GIA = 'gia-amplitude',
  AMPLITUDE = 'amplitude',
  USER_FLOW_TRACKER = 'user-flow-tracker',
}

export const enum OutbrainEventName {
  PAGE_VIEW = 'PAGE_VIEW',
  ADD_TO_CART = 'Add To Cart',
  CHECKOUT = 'Checkout',
  PURCHASE = 'Purchase',
  COMPLETE_REGISTRATION = 'Lead',
}

export const enum TaboolaEventName {
  PAGE_VIEW = 'page_view',
  ADD_TO_CART = 'add_to_cart',
  CHECKOUT = 'start_checkout',
  PURCHASE = 'make_purchase',
  COMPLETE_REGISTRATION = 'complete_registration',
}

export const enum FBConsentValue {
  REVOKE = 'revoke',
  GRANT = 'grant',
}

export const enum CookieConsentValue {
  STRICTLY_NECESSARY = 'necessary',
  ANALYTICS_AND_PERFORMANCE = 'analytics',
  ADVERTISING_AND_TARGETING = 'advertising',
  FUNCTIONAL_COOKIES = 'functional_cookies',
  REJECT_ALL = 'reject_all',
}

export const enum HOT_JAR_CLIENT_ID {
  PROD = '3903825',
  DEV = '3907148',
}

export const APPLOVIN_CATEGORY_ID = 2890
